import { put } from 'redux-saga/effects';
import { ERROR_MESSAGES } from '@/constants/events';
import orderStatusActions from '@/redux/orderStatus/actions';
import * as ErrorReporter from '@/utils/errorReporter';

/**
 * A setConveyance whose gateway failed twice (`retryOnceOnStatuses` + `GATEWAY_STATUSES`) left
 * the handoff unsaved: open the cart-preserving conveyance recovery modal, then report it.
 *
 * The caller keeps its own `isStatusError` gate and decides what happens after.
 */
export function* surfaceConveyanceGatewayFailure(error: unknown) {
  yield put(orderStatusActions.recovery502Triggered('conveyance'));
  ErrorReporter.captureException(error, 'error', {
    eventName: ERROR_MESSAGES.SET_CONVEYANCE_ERROR,
  });
}
